import React from 'react';
import { Navigate } from 'react-router-dom';
import _ from 'lodash';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import AccountView from 'src/views/account/AccountView';
import CustomerListView from 'src/views/customer/CustomerListView';
import AckListView from 'src/views/acknowledgement/AckListView';
import DashboardView from 'src/views/reports/DashboardView';
import LoginView from 'src/views/auth/LoginView';
import NotFoundView from 'src/views/errors/NotFoundView';
import InvoiceListView from 'src/views/invoices/InvoiceListView';
import SettingsView from 'src/views/settings/SettingsView';

const routes = (isLoggedIn, keycloak) => {
  const roles = _.get(keycloak, ['realmAccess', 'roles'], []);

  return [
    {
      path: 'app',
      element: isLoggedIn ? <DashboardLayout keycloak={keycloak} /> : <Navigate to="/login" />,
      children: [
        { path: 'dashboard', exact: true, element: _.includes(roles, 'view-dashboard') && <DashboardView keycloak={keycloak} /> },
        { path: 'account', exact: true, element: _.includes(roles, 'view-account') ? <AccountView keycloak={keycloak} /> : <Navigate to="/404" /> },
        { path: 'customers', exact: true, element: _.includes(roles, 'view-customers') ? <CustomerListView keycloak={keycloak} /> : <Navigate to="/404" /> },
        { path: 'acknowledgements', exact: true, element: _.includes(roles, 'view-acknowledgements') ? <AckListView keycloak={keycloak} /> : <Navigate to="/404" /> },
        { path: 'invoices', exact: true, element: _.includes(roles, 'view-invoices') ? <InvoiceListView keycloak={keycloak} /> : <Navigate to="/404" /> },
        { path: 'settings', exact: true, element: _.includes(roles, 'view-settings') ? <SettingsView keycloak={keycloak} /> : <Navigate to="/404" /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    },
    {
      path: '/',
      element: !isLoggedIn ? <MainLayout /> : <Navigate to="/app/dashboard" />,
      children: [
        { path: 'login', exact: true, element: <LoginView /> },
        { path: '404', exact: true, element: <NotFoundView /> },
        { path: '/', exact: true, element: <Navigate to="/login" /> },
        { path: '*', element: <Navigate to="/404" /> }
      ]
    }
  ];
};

export default routes;
